const maintenancesOutput = {
  title_scheduled: `Scheduled Maintenances`,
  title_pending: `Pending Maintenances`,
  title_progress: `Maintenances in Progress`,
  title_expired: `Expíred Maintenances`,
  title_completed: `Completed Maintenances`,
  title_overdue: `Overdue Maintenances`,
  title: 'Maintenances',
};

export default maintenancesOutput;